// Planar UVs for a knife model's blade that match the finish texture's layout (finishTexture.ts):
// the canvas covers the procedural blade's shape coordinates x 0.9..1.9 (base -> tip) and
// y -0.6..0.25 (across), so every knife's blade wears a finish the same way the karambit's does.

import * as THREE from 'three';

const UV_X = [0.9, 1.9];
const UV_Y = [-0.6, 0.25];

/** `along` points from the blade's base to its tip, `across` across its flat side (unit vectors). */
export function projectBladeUvs(
  geo: THREE.BufferGeometry,
  origin: THREE.Vector3,
  along: THREE.Vector3,
  across: THREE.Vector3,
) {
  const pos = geo.getAttribute('position');
  const p = new THREE.Vector3();
  const a = new Float32Array(pos.count);
  const c = new Float32Array(pos.count);
  let minA = Infinity;
  let maxA = -Infinity;
  let minC = Infinity;
  let maxC = -Infinity;
  for (let i = 0; i < pos.count; i++) {
    p.fromBufferAttribute(pos, i).sub(origin);
    a[i] = p.dot(along);
    c[i] = p.dot(across);
    minA = Math.min(minA, a[i]);
    maxA = Math.max(maxA, a[i]);
    minC = Math.min(minC, c[i]);
    maxC = Math.max(maxC, c[i]);
  }
  const uv = new Float32Array(pos.count * 2);
  for (let i = 0; i < pos.count; i++) {
    uv[i * 2] = UV_X[0] + ((a[i] - minA) / (maxA - minA)) * (UV_X[1] - UV_X[0]);
    uv[i * 2 + 1] = UV_Y[0] + ((c[i] - minC) / (maxC - minC)) * (UV_Y[1] - UV_Y[0]);
  }
  geo.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
}
